import React from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

// Define constants for links and contact info
const CONTACT_INFO = {
  phone: '0 (232) 479 16 73',
  phoneHref: 'tel:+902324791673',
  email: 'info@fibrosan.com.tr',
  emailHref: 'mailto:info@fibrosan.com.tr',
  mapLink: 'https://fibrosan.com.tr/iletisim/', // IMPORTANT: Replace with your actual Google Maps link or desired URL
};

const QUICK_LINKS = [
  { name: 'Hakkımızda', href: '/hakkimizda' },
  { name: 'Hizmetlerimiz', href: '/hizmetler' },
  { name: 'Projelerimiz', href: '/projeler' },
  { name: 'Blog', href: '/blog' },
];

function Footer() {
  return (
    <footer className="bg-[#3C5551] text-gray-100 py-12 px-4 sm:px-6 lg:px-8 shadow-lg" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">Site Footer</h2>
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 text-center md:text-left">

        {/* Contact Information Section */}
        <div className="flex flex-col items-center md:items-start space-y-3">
          <h3 className="text-xl font-semibold text-orange-300 mb-3">İletişim</h3>
          <div className="flex items-center space-x-3">
            <FaPhoneAlt className="text-lg text-orange-300" aria-hidden="true" />
            <a
              href={CONTACT_INFO.phoneHref}
              className="text-base font-light hover:text-orange-300 transition-colors duration-300"
              aria-label={`Call us at ${CONTACT_INFO.phone}`}
            >
              {CONTACT_INFO.phone}
            </a>
          </div>
          <div className="flex items-center space-x-3">
            <FaEnvelope className="text-lg text-orange-300" aria-hidden="true" />
            <a
              href={CONTACT_INFO.emailHref}
              className="text-base font-light hover:text-orange-300 transition-colors duration-300"
              aria-label={`Email us at ${CONTACT_INFO.email}`}
            >
              {CONTACT_INFO.email}
            </a>
          </div>
        </div>

        {/* Quick Links / Navigation Section */}
        <nav className="flex flex-col items-center md:items-start space-y-3" aria-label="Quick Links">
          <h3 className="text-xl font-semibold text-orange-300 mb-3">Hızlı Bağlantılar</h3>
          <ul className="space-y-2">
            {QUICK_LINKS.map((link) => (
              <li key={link.name}>
                <a
                  href={link.href}
                  className="text-base font-light hover:text-orange-300 transition-colors duration-300"
                >
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {/* Location / Map Section */}
        <div className="flex flex-col items-center md:items-start space-y-3">
          <h3 className="text-xl font-semibold text-orange-300 mb-3">Konum</h3>
          <div className="flex items-center space-x-3">
            <FaMapMarkerAlt className="text-lg text-orange-300" aria-hidden="true" />
            <a
              href={CONTACT_INFO.mapLink}
              target="_blank"
              rel="noopener noreferrer"
              className="text-base font-light hover:text-orange-300 transition-colors duration-300 cursor-pointer"
              aria-label="View our location on Google Maps"
            >
              Ulaşım Haritaları
            </a>
          </div>
          {/* Optional: Add a physical address here */}
          {/* <p className="text-sm font-light text-gray-300 mt-2">Örnek Mah. Örnek Cad. No: 123, İzmir, Türkiye</p> */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;